import usePlankTableStore from './usePlankTableStore';

const useSidepanelActions = () => {
  const closeSidepanel = usePlankTableStore((state) => state.closeSidepanel);
  const moveDefectToOnderhoud = usePlankTableStore((state) => state.moveDefectToOnderhoud);
  const moveDefectFromOnderhoud = usePlankTableStore((state) => state.moveDefectFromOnderhoud);
  const resetNotities = usePlankTableStore((state) => state.resetNotities);
  const setTab = usePlankTableStore((state) => state.setTab);
  const setEenheid = usePlankTableStore((state) => state.setEenheid);
  const setSidepanelVoorraad = usePlankTableStore((state) => state.setSidepanelVoorraad);
  const setSidepanelVoorraadRegionaal = usePlankTableStore((state) => state.setSidepanelVoorraadRegionaal);
  const setIsAccepteerDialogOpen = usePlankTableStore((state) => state.setIsAccepteerDialogOpen);
  const updateIsBusy = usePlankTableStore((state) => state.updateIsBusy);
  const updateNotitieStatus = usePlankTableStore((state) => state.updateNotitieStatus);
  const updateNotitieOpmerking = usePlankTableStore((state) => state.updateNotitieOpmerking);
  return {
    closeSidepanel,
    moveDefectToOnderhoud,
    moveDefectFromOnderhoud,
    setTab,
    setEenheid,
    setSidepanelVoorraad,
    setSidepanelVoorraadRegionaal,
    setIsAccepteerDialogOpen,
    updateIsBusy,
    resetNotities,
    updateNotitieStatus,
    updateNotitieOpmerking,
  };
};
export default useSidepanelActions;
